export default __webpack_public_path__ + "static/blogtonft-21560da7fba27f4c42c48f214202d632.jpeg";